var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplosionNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3332 14.6667L22.1952 13.8047C22.3446 13.6552 22.4632 13.4778 22.5441 13.2825C22.6249 13.0873 22.6666 12.878 22.6665 12.6667C22.6665 12.4899 22.7368 12.3203 22.8618 12.1953C22.9868 12.0702 23.1564 12 23.3332 12H23.9999M14.6665 18.6667C14.6665 18.1362 14.8773 17.6275 15.2523 17.2525C15.6274 16.8774 16.1361 16.6667 16.6665 16.6667M22.4332 15.7667C22.5076 15.841 22.5666 15.9292 22.6069 16.0263C22.6471 16.1234 22.6678 16.2275 22.6678 16.3327C22.6678 16.4378 22.6471 16.5419 22.6069 16.639C22.5666 16.7361 22.5076 16.8244 22.4332 16.8987L21.7852 17.5467C22.1088 18.6134 22.0666 19.7576 21.6654 20.7976C21.2643 21.8375 20.5271 22.7137 19.571 23.2867C18.6149 23.8598 17.4947 24.0969 16.3884 23.9604C15.2821 23.824 14.2532 23.3218 13.465 22.5336C12.6768 21.7454 12.1746 20.7164 12.0381 19.6101C11.9016 18.5038 12.1388 17.3837 12.7118 16.4276C13.2849 15.4715 14.161 14.7343 15.201 14.3331C16.241 13.9319 17.3852 13.8898 18.4519 14.2133L19.0999 13.5653C19.1742 13.491 19.2624 13.4319 19.3595 13.3917C19.4566 13.3514 19.5607 13.3307 19.6659 13.3307C19.771 13.3307 19.8751 13.3514 19.9722 13.3917C20.0693 13.4319 20.1576 13.491 20.2319 13.5653L22.4332 15.7667Z",
    stroke: "#A10505",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosionNotifications);
export default __webpack_public_path__ + "static/media/explosion-notifications.5b09350fd675cbdef10d5b37c8484dc3.svg";
export { ForwardRef as ReactComponent };